import {get} from 'lodash';

export default (state = {}, {coachId, res}: any) => {
  return {
    ...state,
    sameDayLastMonth: {
      ...get(state, 'sameDayLastMonth', {}),
      [coachId]: res[0],
    },
  };
};
